import { isNull } from '../common';
import { instance } from './instance-api';
import { differenceInMinutes } from 'date-fns';

export interface RateLimit {
    like?: Rate;
    follow?: Rate;
    auth?: Rate;
}

interface Rate {
    rate_limited: boolean;
    reset_timestamp: number;
    nextMinutes?: number;
}

export const getRateLimit = async () => {
    const response = await instance.post<RateLimit>('/rate_limit').catch(() => null);
    if (isNull(response) || isNull(response.data)) return {};
    const out = response.data;
    // @ts-ignore
    out.like.nextMinutes = getNextRefreshinMinutes(out.like.reset_timestamp);
    // @ts-ignore
    out.follow.nextMinutes = getNextRefreshinMinutes(out.follow.reset_timestamp);
    // @ts-ignore
    out.auth.nextMinutes = getNextRefreshinMinutes(out.auth.reset_timestamp);
    return out;
};

const getNextRefreshinMinutes = (resetTime: number | undefined): number => {
    const now = new Date();
    const random = Math.ceil(Math.random() * 10);
    if (!resetTime || resetTime === 0) return random;
    const diffInMinutes = differenceInMinutes(new Date(resetTime * 1000), now);
    return Math.ceil(diffInMinutes + random);
};
